export default __webpack_public_path__ + "static/media/MOTOS.0d09656d.png";